// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._mekaalBQZt9psr7y62z {
	flex-shrink: 0;
	width: 100%;
	z-index: 100;
}

.O8sRDuOg_b7Z4IioAR5r {
	position: absolute;
	left: calc(100% + 10px);
	top: 3px;
	display: flex;
    justify-content: center;
    border-radius: 6px;
    padding: 2px 10px;
    font-size: 10px;
    line-height: 1.3;
    background-color: #75fb6e;
    color: #000;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.pcss"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,QAAQ;CACR,aAAa;IACV,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".header {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tz-index: 100;\n}\n\n.new {\n\tposition: absolute;\n\tleft: calc(100% + 10px);\n\ttop: 3px;\n\tdisplay: flex;\n    justify-content: center;\n    border-radius: 6px;\n    padding: 2px 10px;\n    font-size: 10px;\n    line-height: 1.3;\n    background-color: #75fb6e;\n    color: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_mekaalBQZt9psr7y62z`,
	"new": `O8sRDuOg_b7Z4IioAR5r`
};
export default ___CSS_LOADER_EXPORT___;
